import Column from '@components/column'
import Title from '@components/title'
import React from 'react'

import LocationSetupList from './list'
import LocationSetupForm from './form'

const LocationSetup = () => {
  return (
    <>
      <Column>
        <Title textone="Location" texttwo="Setup" />
        <LocationSetupForm />
        <LocationSetupList />
      </Column>
    </>
  )
}

export default LocationSetup
